import React, { useMemo, useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableHead, TableRow,
  Paper, makeStyles,
} from '@material-ui/core';
import { fmtDate } from './manufacturingTabData';
import Pagination from '../../logisticsDashboard/components/Pagination';


// ── Batch Yield data, per batch, sourced from the "Batch Yield" tab of each
//    Manufacturing Collaboration workbook. Selected by the batch number of the
//    expanded main-table row; any other batch falls back to a representative
//    dataset ("similar to excel"). ──────────────────────────────────────────────
const YIELD_2388 = {
  summary: {
    batchNumber: '2388-OXB-A-1',
    plannedQuantity: 'Per BMR target',
    actualQuantity: '21 aliquots (302.4 - 308.4 g; 6407.2 g dispensed)',
    uom: 'g (UDFD aliquoted; UDFD available 6418.4 g, 11.2 g remaining)',
    molarYield: 'NA',
    mfgDate: '17-MAY-2025',
    expiryDate: '17-MAY-2027',
    storageCondition: 'Blast-frozen bulk drug substance (UDFD aliquots)',
    storageLocation: 'Cold Storage Vault CSV-07, Building 8, CMO Site (1733 TW Alexander Drive, Durham, NC 27703)',
  },
  rows: [
    { category: 'Final product', item: '2388-OXB-A-1-01', stream: 'UDFD aliquot (blast-frozen)', quantity: '308.4', uom: 'g', tu: '5.71×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-02', stream: 'UDFD aliquot (blast-frozen)', quantity: '307.7', uom: 'g', tu: '5.69×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-03', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.3', uom: 'g', tu: '5.63×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-04', stream: 'UDFD aliquot (blast-frozen)', quantity: '303.1', uom: 'g', tu: '5.61×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-05', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.4', uom: 'g', tu: '5.59×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-06', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.4', uom: 'g', tu: '5.63×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-07', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.5', uom: 'g', tu: '5.63×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-08', stream: 'UDFD aliquot (blast-frozen)', quantity: '307', uom: 'g', tu: '5.68×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-09', stream: 'UDFD aliquot (blast-frozen)', quantity: '306.3', uom: 'g', tu: '5.67×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-10', stream: 'UDFD aliquot (blast-frozen)', quantity: '306.7', uom: 'g', tu: '5.67×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-11', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.8', uom: 'g', tu: '5.64×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-12', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.1', uom: 'g', tu: '5.64×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-13', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.3', uom: 'g', tu: '5.65×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-14', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.8', uom: 'g', tu: '5.66×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-15', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.3', uom: 'g', tu: '5.65×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-16', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.7', uom: 'g', tu: '5.66×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-17', stream: 'UDFD aliquot (blast-frozen)', quantity: '306.4', uom: 'g', tu: '5.67×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-18', stream: 'UDFD aliquot (blast-frozen)', quantity: '303.8', uom: 'g', tu: '5.62×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-19', stream: 'UDFD aliquot (blast-frozen)', quantity: '303.3', uom: 'g', tu: '5.61×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-20', stream: 'UDFD aliquot (blast-frozen)', quantity: '304', uom: 'g', tu: '5.62×10^10', basis: 'Measured' },
    { category: '', item: '2388-OXB-A-1-21', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.9', uom: 'g', tu: '5.60×10^10', basis: 'Measured' },
    { category: '', item: 'Total dispensed (21 aliquots)', stream: '', quantity: '6407.2', uom: 'g', tu: '1.19×10^12', basis: '' },
    { category: 'Unit procedure', item: 'UP 3 - Production bioreactor (200 L)', stream: 'Rapid harvest (post-sampling)', quantity: '395.05', uom: 'kg', tu: '3.31×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 4 - Clarification (CLHV)', stream: 'Clarified harvest (0.2 um)', quantity: '435.1', uom: 'L', tu: '2.98×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 5 - Cation Exchange (CEX / CIEX, Sartobind S)', stream: 'CIEX flow-through pool', quantity: '440.1', uom: 'kg', tu: '2.53×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 6 - Anion Exchange (AEX / AIEX, Sartobind Q)', stream: 'AIEX eluate pool', quantity: '18338.5', uom: 'g', tu: '1.52×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 7 - UF/DF (HFF)', stream: 'Final vector substance (UDFD)', quantity: '6573.5', uom: 'g', tu: '1.22×10^12', basis: 'Measured: 1.85 x10^8 TU/mL x 6573.5 g' },
    { category: '', item: 'UP 8 - Aliquoting & blast-freezing', stream: 'UDFD dispensed (21 aliquots)', quantity: '6407.2', uom: 'g', tu: '1.19×10^12', basis: 'Measured: 1.85 x10^8 TU/mL x 6407.2 g (dispensed)' },
  ],
};

const YIELD_2785 = {
  summary: {
    batchNumber: '2785-OXB-B-1',
    plannedQuantity: 'Per BMR target',
    actualQuantity: '20 aliquots (301.5 - 307.2 g; 6067.7 g dispensed)',
    uom: 'g (UDFD aliquoted; UDFD available 6109.1 g, 41.4 g remaining)',
    molarYield: 'NA',
    mfgDate: '18-OCT-2025',
    expiryDate: '05-NOV-2027',
    storageCondition: 'Blast-frozen bulk drug substance (UDFD aliquots)',
    storageLocation: 'Cold Storage Vault CSV-07, Building 8, CMO Site (1733 TW Alexander Drive, Durham, NC 27703)',
  },
  rows: [
    { category: 'Final product', item: '2785-OXB-B-1-01', stream: 'UDFD aliquot (blast-frozen)', quantity: '307.2', uom: 'g', tu: '5.22×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-02', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.9', uom: 'g', tu: '5.18×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-03', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.4', uom: 'g', tu: '5.14×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-04', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.9', uom: 'g', tu: '5.15×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-05', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.6', uom: 'g', tu: '5.14×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-06', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.1', uom: 'g', tu: '5.19×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-07', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.9', uom: 'g', tu: '5.15×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-08', stream: 'UDFD aliquot (blast-frozen)', quantity: '303.1', uom: 'g', tu: '5.15×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-09', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.1', uom: 'g', tu: '5.14×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-10', stream: 'UDFD aliquot (blast-frozen)', quantity: '301.5', uom: 'g', tu: '5.13×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-11', stream: 'UDFD aliquot (blast-frozen)', quantity: '305.1', uom: 'g', tu: '5.19×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-12', stream: 'UDFD aliquot (blast-frozen)', quantity: '303', uom: 'g', tu: '5.15×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-13', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.1', uom: 'g', tu: '5.14×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-14', stream: 'UDFD aliquot (blast-frozen)', quantity: '302.7', uom: 'g', tu: '5.15×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-15', stream: 'UDFD aliquot (blast-frozen)', quantity: '304.1', uom: 'g', tu: '5.17×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-16', stream: 'UDFD aliquot (blast-frozen)', quantity: '302', uom: 'g', tu: '5.13×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-17', stream: 'UDFD aliquot (blast-frozen)', quantity: '304', uom: 'g', tu: '5.17×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-18', stream: 'UDFD aliquot (blast-frozen)', quantity: '304', uom: 'g', tu: '5.16×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-19', stream: 'UDFD aliquot (blast-frozen)', quantity: '303', uom: 'g', tu: '5.14×10^10', basis: 'Measured' },
    { category: '', item: '2785-OXB-B-1-20', stream: 'UDFD aliquot (blast-frozen)', quantity: '304', uom: 'g', tu: '5.16×10^10', basis: 'Measured' },
    { category: '', item: 'Total dispensed (20 aliquots)', stream: '', quantity: '6068', uom: 'g', tu: '1.03×10^12', basis: '' },
    { category: 'Unit procedure', item: 'UP 3 - Production bioreactor (200 L)', stream: 'Rapid harvest (post-sampling)', quantity: '374', uom: 'kg', tu: '2.89×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 4 - Clarification (CLHV)', stream: 'Clarified harvest (0.2 um)', quantity: '415.2', uom: 'kg', tu: '2.60×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 5 - Cation Exchange (CEX / CIEX, Sartobind S)', stream: 'CIEX flow-through pool', quantity: '419.7', uom: 'kg', tu: '2.21×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 6 - Anion Exchange (AEX / AIEX, Sartobind Q)', stream: 'AIEX eluate pool', quantity: '18398.3', uom: 'g', tu: '1.33×10^12', basis: 'Estimate (back-calculated)' },
    { category: '', item: 'UP 7 - UF/DF (HFF)', stream: 'Final vector substance (UDFD)', quantity: '6235.5', uom: 'g', tu: '1.06×10^12', basis: 'Measured: 1.70x10^8 TU/mL x 6235.5 g' },
    { category: '', item: 'UP 8 - Aliquoting & blast-freezing', stream: 'UDFD dispensed (20 aliquots)', quantity: '6067.7', uom: 'g', tu: '1.03×10^12', basis: 'Measured: 1.70x10^8 TU/mL x 6067.7 g (dispensed)' },
  ],
};

const YIELD_TZB = {
  countLabel: 'Protein content (g)',
  summary: {
    batchNumber: 'TZB2401-DS',
    plannedQuantity: '30 x 1 L bags (~6.00 kg DS @ 20 g/L)',
    actualQuantity: '27 x 1 L bags (~5.40 kg DS)',
    uom: 'EA (1 L Flexsafe 2D bags @ 20 g/L)',
    molarYield: '',
    mfgDate: '01-FEB-2026',
    expiryDate: '01-FEB-2028',
    storageCondition: 'Store at -40 C +/- 5 C; do not refreeze once thawed.',
    storageLocation: 'Cold Storage Vault CSV-04, Building 14, CMO Site (Greenville, NC, USA)',
  },
  rows: [
    { category: 'In-process', item: '3 (Production Bioreactor)', stream: 'Harvest titer at EOP', quantity: '4.2', uom: 'g/L', tu: '', basis: 'Measured (Protein A HPLC)' },
    { category: '', item: '4 (Harvest & Clarification)', stream: 'Clarified Trastuzumab titer', quantity: '4.20', uom: 'g/L', tu: '', basis: 'Measured' },
    { category: '', item: '5 (Protein A Capture)', stream: 'Protein A eluate pool (HCP 1850 ppm)', quantity: '—', uom: '—', tu: '', basis: 'Measured (CQA panel)' },
    { category: '', item: '7 (Polishing Chromatography)', stream: 'CEX/AEX polished pool (HMW 0.85 %)', quantity: '—', uom: '—', tu: '', basis: 'Measured' },
    { category: '', item: '9 (UF/DF)', stream: 'Formulated bulk DS', quantity: '20.1', uom: 'g/L', tu: '', basis: 'Measured (A280)' },
    { category: 'Final product', item: '11 (Fill & Freeze)', stream: 'DS aseptic bag fill, 27 x 1 L bags', quantity: '~5.40', uom: 'kg', tu: '5400', basis: 'Measured (gravimetric)' },
    { category: '', item: 'TZB2401-DS-bag-avg', stream: 'Per-bag fill weight', quantity: '1.005', uom: 'kg', tu: '201', basis: 'Measured' },
  ],
};

const YIELD_DATASETS = {
  '2388-OXB-A-1': YIELD_2388,
  '2785-OXB-B-1': YIELD_2785,
  'TZB2401-DS': YIELD_TZB,
};
const DEFAULT_YIELD_BATCH = '2388-OXB-A-1';

// Deep-clone a value, replacing every occurrence of the template batch token
// with the actual batch — so an unmapped batch shows representative data that
// carries its own batch number and aliquot ids (2388-OXB-A-1 -> <batch>,
// 2388-OXB-A-1-01 -> <batch>-01) instead of the template's.
const deepReplace = (val, from, to) => {
  if (typeof val === 'string') return val.split(from).join(to);
  if (Array.isArray(val)) return val.map((v) => deepReplace(v, from, to));
  if (val && typeof val === 'object') {
    const out = {};
    Object.keys(val).forEach((k) => { out[k] = deepReplace(val[k], from, to); });
    return out;
  }
  return val;
};

export const selectYield = (rowData) => {
  const key = rowData && rowData.batchNumber ? String(rowData.batchNumber).trim() : '';
  if (key && YIELD_DATASETS[key]) return YIELD_DATASETS[key]; // known batch → exact data
  if (key) return deepReplace(YIELD_DATASETS[DEFAULT_YIELD_BATCH], DEFAULT_YIELD_BATCH, key); // other → remapped
  return YIELD_DATASETS[DEFAULT_YIELD_BATCH]; // no batch on the row → template as-is
};

// Summary laid out in three columns (label stacked over value), matching the
// Batch Yield design: identity/quantities | measurement/dates | storage.
const SUMMARY_COLUMNS = [
  [
    { label: 'Batch Number', key: 'batchNumber' },
    { label: 'Planned Product Quantity', key: 'plannedQuantity' },
    { label: 'Actual Product Quantity', key: 'actualQuantity' },
  ],
  [
    { label: 'UOM', key: 'uom' },
    { label: 'Molar Yield', key: 'molarYield' },
    { label: 'Batch Manufacturing Date', key: 'mfgDate', isDate: true },
    
  ],
  [
    { label: 'Storage Condition', key: 'storageCondition' },
    { label: 'Storage Location', key: 'storageLocation' },
    { label: 'Expiry Date', key: 'expiryDate', isDate: true },
  ],
];

const useStyles = makeStyles(() => ({
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    margin: '8px 0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  summaryBox: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    columnGap: 40,
    padding: '14px 20px 16px',
    alignItems: 'start',
  },
  summaryColumn: { display: 'flex', flexDirection: 'column' },
  summaryField: { padding: '6px 0' },
  summaryLabel: {
    fontSize: '0.8rem',
    fontWeight: 700,
    color: '#333',
    lineHeight: 1.45,
    marginBottom: 2,
  },
  summaryValue: { fontSize: '0.83rem', color: '#555', lineHeight: 1.45, wordBreak: 'break-word' },
  headerRow: {
    '& th': {
      backgroundColor: '#F9F9FC',
      fontWeight: 700,
      fontSize: '0.8rem',
      color: '#333',
      padding: '9px 12px',
      borderTop: '1px solid #e0e0e0',
      borderBottom: '1px solid #e0e0e0',
      verticalAlign: 'bottom',
      lineHeight: 1.3,
      whiteSpace: 'normal',
      wordBreak: 'normal',
      overflowWrap: 'normal',
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
  },
  scrollArea: {
    width: '100%',
    maxHeight: 440,
    overflowY: 'auto',
    overflowX: 'auto',
  },
  bodyRow: {
    '&:hover': { backgroundColor: '#fafbfc' },
    '& td': {
      fontSize: '0.85rem',
      padding: '8px 12px',
      borderBottom: '1px solid #eeeeee',
      color: '#444',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
  categoryCell: { fontWeight: 600, color: '#333' },
}));

const YieldTab = ({ loading, rowData, pageSize = 10 }) => {
  const classes = useStyles();
  const PAGE_SIZE = pageSize || 10;
  const dataset = useMemo(() => selectYield(rowData), [rowData]);

  const { summary, rows } = dataset;

  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const pageRows = useMemo(
    () => rows.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE),
    [rows, safePage, PAGE_SIZE]
  );

  if (loading) return <Box style={{ textAlign: 'center', padding: 24 }}>Loading...</Box>;

  return (
    <Paper className={classes.card} elevation={0}>
      {/* Batch summary — three columns, label stacked over value */}
      <Box className={classes.summaryBox}>
        {SUMMARY_COLUMNS.map((col, ci) => (
          <Box key={ci} className={classes.summaryColumn}>
            {col.map((f) => (
              <Box key={f.key} className={classes.summaryField}>
                <Typography className={classes.summaryLabel}>{f.label}</Typography>
                <Typography className={classes.summaryValue}>{(f.isDate ? fmtDate(summary[f.key]) : summary[f.key]) || '—'}</Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>

      {/* Yield - by Aliquot and Unit Procedure */}
      <div className={classes.scrollArea}>
        <Table stickyHeader size="small" style={{ width: '100%', tableLayout: 'auto' }}>
          <colgroup>
            <col style={{ width: '9%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '22%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '16%' }} />
            <col style={{ width: '22%' }} />
          </colgroup>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell>Category</TableCell>
              <TableCell>Level / Item</TableCell>
              <TableCell>Yield Stream / Description</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>UOM</TableCell>
              <TableCell>{dataset.countLabel || 'Viral Vector Count (TU)'}</TableCell>
              <TableCell>Basis</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow><TableCell colSpan={7} style={{ textAlign: 'center' }}>No data available</TableCell></TableRow>
            ) : pageRows.map((r, idx) => (
              <TableRow key={idx} className={classes.bodyRow}>
                <TableCell className={r.category ? classes.categoryCell : undefined}>{r.category}</TableCell>
                <TableCell>{r.item}</TableCell>
                <TableCell>{r.stream}</TableCell>
                <TableCell>{r.quantity}</TableCell>
                <TableCell>{r.uom}</TableCell>
                <TableCell>{r.tu}</TableCell>
                <TableCell>{r.basis}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {rows.length > PAGE_SIZE && (
        <Pagination page={safePage} totalPages={totalPages} onChange={setPage} />
      )}
    </Paper>
  );
};

export default YieldTab;
